<template>
  <IconLucideArrowLeft />
</template>
